import { render, staticRenderFns } from "./SoleProprietorshipOfferList.vue?vue&type=template&id=cda88fc2&scoped=true"
import script from "./SoleProprietorshipOfferList.vue?vue&type=script&lang=js"
export * from "./SoleProprietorshipOfferList.vue?vue&type=script&lang=js"
import style0 from "./SoleProprietorshipOfferList.vue?vue&type=style&index=0&id=cda88fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda88fc2",
  null
  
)

export default component.exports